// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i6QM","controls":"styles_controls__J9enx","charLimit":"styles_charLimit__3J6uk","input":"styles_input__1XnVG","send":"styles_send__QLQfW"};